(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-toy-quiz"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atelier-toy-quiz')) {
  customElements.define('atelier-toy-quiz', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), {once: true, signal: this.events.signal});
      } else {
        this.initialize();
      }
    }
    initialize() {
      if (!this.isConnected) return;
      this.steps = [...this.querySelectorAll('[data-quiz-step]')];
      this.intro = this.querySelector('[data-quiz-intro]');
      this.flow = this.querySelector('[data-quiz-flow]');
      this.results = this.querySelector('[data-quiz-results]');
      this.form = this.querySelector('form');
      this.index = 0;
      const seen = new Set();
      this.candidates = [...this.querySelectorAll('template[data-quiz-product]')].filter(template => {
        const id = template.dataset.productId;
        const price = Number(template.dataset.price);
        if (!id || seen.has(id) || !Number.isFinite(price) || price < 0 || template.dataset.price.trim() === '') return false;
        seen.add(id);
        return true;
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-quiz-action]');
        if (!button || !this.contains(button)) return;
        const action = button.dataset.quizAction;
        if (action === 'start') this.showStep(0);
        if (action === 'back') this.showStep(this.index - 1);
        if (action === 'edit') this.showStep(0);
        if (action === 'restart') {
          this.form.reset();
          this.querySelector('[data-quiz-grid]').replaceChildren();
          this.querySelector('[data-quiz-summary]').replaceChildren();
          this.showStep(0);
        }
      }, {signal: this.events.signal});
      this.addEventListener('change', event => {
        if (event.target.matches('input[type="radio"]')) this.updateNext();
      }, {signal: this.events.signal});
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (!this.steps[this.index].querySelector('input:checked')) return;
        if (this.index < this.steps.length - 1) this.showStep(this.index + 1);
        else this.showResults();
      }, {signal: this.events.signal});
      this.querySelector('[data-quiz-action="start"]').hidden = false;
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
    }
    showStep(index) {
      if (index < 0) {
        this.intro.hidden = false;
        this.flow.hidden = true;
        this.results.hidden = true;
        this.focusPanel(this.intro.querySelector('h1'));
        return;
      }
      this.index = Math.min(index, this.steps.length - 1);
      this.intro.hidden = true;
      this.flow.hidden = false;
      this.results.hidden = true;
      this.steps.forEach((step, i) => {
        step.hidden = i !== this.index;
        step.disabled = i !== this.index;
      });
      const position = this.index + 1;
      const progress = this.querySelector('progress');
      progress.max = this.steps.length;
      progress.value = position;
      this.querySelector('[data-quiz-progress-label]').textContent = this.dataset.progressLabel.replace('[step]', position);
      this.querySelector('[data-quiz-step-number]').textContent = String(position).padStart(2, '0');
      this.updateNext();
      this.focusPanel(this.steps[this.index].querySelector('legend'));
    }
    updateNext() {
      const next = this.querySelector('[data-quiz-next]');
      next.disabled = !this.steps[this.index].querySelector('input:checked');
      next.querySelector('span').textContent = this.index === this.steps.length - 1 ? this.dataset.resultsLabel : this.dataset.nextLabel;
    }
    focusPanel(target) {
      if (!target) return;
      target.focus({preventScroll: true});
      const top = this.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * .55) this.scrollIntoView({block: 'start', behavior: 'instant'});
    }
    showResults() {
      const answers = {};
      const labels = {};
      for (const [index, step] of this.steps.entries()) {
        const selected = step.querySelector('input:checked');
        if (!selected) { this.showStep(index); return; }
        answers[step.dataset.quizStep] = selected.value;
        labels[step.dataset.quizStep] = selected.closest('label').querySelector('.aq-choice__title').textContent.trim();
      }
      const low = Number(this.dataset.budgetLow);
      const high = Number(this.dataset.budgetHigh);
      const has = (template, property, value) => (template.dataset[property] || '').split(/\s+/).includes(value);
      const matches = this.candidates.filter(template => {
        const price = Number(template.dataset.price);
        if (answers.audience !== 'any' && !has(template, 'audiences', answers.audience)) return false;
        if (answers.feeling !== 'any' && !has(template, 'feelings', answers.feeling)) return false;
        if (answers.budget === 'low' && price >= low) return false;
        if (answers.budget === 'mid' && (price < low || price > high)) return false;
        if (answers.budget === 'high' && price <= high) return false;
        return true;
      }).map((template, order) => ({
        template,
        order,
        score: answers.priority !== 'any' && has(template, 'priorities', answers.priority) ? 1 : 0
      })).sort((a, b) => b.score - a.score || a.order - b.order).slice(0, Math.max(1, Math.min(4, Number(this.dataset.resultLimit) || 3)));
      const grid = this.querySelector('[data-quiz-grid]');
      grid.replaceChildren();
      for (const match of matches) {
        const fragment = match.template.content.cloneNode(true);
        const reason = fragment.querySelector('[data-match-reason]');
        const reasons = [];
        if (answers.feeling !== 'any') reasons.push(labels.feeling);
        if (match.score) reasons.push(labels.priority);
        reason.textContent = reasons.join(' · ');
        reason.hidden = !reasons.length;
        grid.append(fragment);
      }
      const summary = this.querySelector('[data-quiz-summary]');
      summary.replaceChildren();
      for (const label of Object.values(labels)) {
        const item = document.createElement('li');
        item.textContent = label;
        summary.append(item);
      }
      const empty = matches.length === 0;
      this.querySelector('[data-quiz-empty]').hidden = !empty;
      grid.hidden = empty;
      this.querySelector('[data-quiz-results-title]').textContent = empty ? this.dataset.emptyHeading : this.dataset.resultsHeading;
      this.querySelector('[data-quiz-status]').textContent = empty ? this.dataset.emptyDescription : this.dataset.resultsDescription;
      this.intro.hidden = true;
      this.flow.hidden = true;
      this.results.hidden = false;
      this.focusPanel(this.querySelector('[data-quiz-results-title]'));
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
